export default {
  glow: {
    active: 'Aktiv',
    blankText: '(tom)',
    clearAll: 'Rensa alla',
    cancel: 'Avbryt',
    close: 'Stäng',
    copied: 'Kopierat',
    confirm: 'Bekräfta',
    copyFailed: 'Kopiering misslyckades',
    copyValue: 'Kopiera {{value}}',
    deselectAll: 'Avmarkera allt',
    dismiss: 'Stäng',
    event: {
      serviceUpgrade: {
        title: 'Service uppgradering',
        curbside: 'Leverans till trottoarkant',
        indoor: 'Inbärning',
        deliveryDate: 'Leveransdatum'
      },
      shorterTimeWindow: {
        title: 'Kortare tidsfönster'
      }
    },
    emptyStates: {
      notFoundTitle: 'Inget resultat',
      notFoundDescription: 'Vi kunde inte hitta några resultat. Justera ditt sökfilter och testa igen.',
      initialTitle: 'Ingen information än',
      successTitle: 'Bra jobbat!'
    },
    filter: 'Filter',
    filterOverlay: {
      filter: 'Filter',
      activeFilterCount: '{{count}} aktivt filter',
      activeFilterCount_other: '{{count}} aktiva filter',
      clearFilter: 'Rensa filter'
    },
    from: 'Från',
    goToPage: 'Gå till sida',
    group: 'Grupp',
    invalidDateFormat: 'Ogiltigt datumformat',
    openCalendar: 'Visa kalender',
    loading: 'Laddar',
    no: 'Nej',
    none: 'Inget val',
    notActivated: 'Inte aktiverad',
    of: 'av',
    orderOfTable: 'Ordning på tabellrubriker',
    orderOfTableDescription:
      'Välj den föredragna ordningen för tabellrubrikerna. Du justerar ordningen genom att dra och släppa.',
    fixedTableHeadersDescription: 'Följande tabellrubriker är fasta och kan inte tas bort eller flyttas.',
    page: 'sida',
    search: 'Sök',
    selectAll: 'Välj alla',
    selectAllCount: 'Välj alla ({{count}})',
    selectAllOnPage: 'Markera allt på sidan ({{count}})',
    settings: 'Inställningar',
    to: 'Till',
    yes: 'Ja',
    accordionMessage: {
      error: '{{count}} felmeddelanden',
      warning: '{{count}} varningsmeddelanden',
      info: '{{count}} informationsmeddelanden',
      general: '{{count}} meddelanden'
    },
    invalidRegistrationNumber: 'Ange ett giltigt registreringsnummer som endast innehåller bokstäver och siffror',
    invalidRegistrationNumber_SE: 'Ogiltigt format. Förväntat: ABC123 eller ABC12D',
    invalidRegistrationNumber_DK: 'Ogiltigt format. Förväntat: AB12345',
    invalidRegistrationNumber_NO: 'Ogiltigt format. Förväntat: AB1234 eller AB12345'
  }
}
